import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomAlertInterface } from './shared/custom-alert/models/custom-alert-interface.model';
import { CustomLoaderComponent } from './shared/custom-loader/custom-loader.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'monitor-logistico-qf';

  logo: string = environment.language;

  @ViewChild(CustomLoaderComponent, { static: true }) loader!: CustomLoaderComponent;

  dsAlert: CustomAlertInterface[] = [];

  constructor() { }

  ngOnInit() { }
}
